<template>
  <section class="page-hospital-form">
    <Breadcrumbs :items="breadcrumbs"/>

    <div class="content">
      <rp-hospital-form
        :editForm="true"
        @submit="updateHospital"
        v-model="form"
        :isAdmin="isAdmin"
        :countries="countries"/>

        <terms/>
      <rp-overlay :active="active">
        <rp-alert
          icon="done"
          :message="successMessage"
          :onClick="successFunction">
        </rp-alert>
      </rp-overlay>
    </div>
  </section>
</template>

<script>
  import HospitalForm from 'raypro_ui/src/components/ui/forms/Hospital'
  import {getHospital, updateHospital} from 'raypro_ui/src/api/hospitals'
  import {getCountries} from 'raypro_ui/src/api/countries'
  import Overlay from 'raypro_ui/src/components/ui/Overlay'
  import Alert from 'raypro_ui/src/components/ui/Alert'
  import page from '@/mixins/page'
  import {mapGetters} from 'vuex'

  import Terms from '@/components/Terms'
  import Breadcrumbs from '@/components/Breadcrumbs'

  export default {
    data() {
      return {
        errors: {},
        form: {logo: {dataUrl: null}},
        countries: [],
        active: false,
        successMessage: 'Hospital updated successfully!',
        title: 'Edit Hospital'
      }
    },

    props: {id: String},

    mounted() {
      this.getCountries()
      this.getHospital()
    },

    mixins: [page],

    computed: {
      ...mapGetters(['authUser']),

      isAdmin() {
        return this.authUser && this.authUser.roles.map((el) => { return el.name }).indexOf('raypro_admin') !== -1
      },

      hospitalPayload() {
        const form = this.form

        let hospital = {
          hospital: {
            'town': form.town,
            'postcode': form.postcode,
            'name': form.name,
            'county': form.county,
            'country_id': form.country.id,
            'address_2': form.address_2,
            'address_1': form.address_1,
            'latlng': form.latitude === '' || form.longitude === '' ? [null, null] : [form.latitude, form.longitude]
          }
        }

        // Only add logo_data_uri to payload if it has a value
        if (form.logo.dataUrl && form.logo.dataUrl !== '') {
          hospital.hospital['logo_data_uri'] = form.logo.dataUrl
        }

        return hospital
      },

      breadcrumbs() {
        return [
          {
            label: 'All Hospitals',
            link: 'hospitals'
          },
          {label: this.form.name}
        ]
      }
    },

    components: {
      'rp-hospital-form': HospitalForm,
      'rp-overlay': Overlay,
      'rp-alert': Alert,
      Terms,
      Breadcrumbs
    },

    methods: {
      successFunction() {
        this.$router.push({name: 'hospitals'})
      },

      getCountries() {
        getCountries().then(({data}) => {
          this.countries = data.map((country) => {
            return {
              name: country.name,
              id: country.id,
              code: country.code
            }
          })
        })
      },

      getHospital() {
        getHospital(this.id).then(({data}) => {
          data.latitude = data.latlng && data.latlng[0]
          data.longitude = data.latlng && data.latlng[1]

          // When loading an existing hospital, add a cache-busting querystring
          // to logo URL to prevent CORS errors in the image edit component
          let logo_url = data.logo_url + `?cachebust=${new Date().getTime()}`
          data.logo = (data.logo_url) ? {sourceUrl: logo_url, dataUrl: null} : {dataUrl: null}
          this.form = data
        })
      },

      updateHospital() {
        updateHospital(this.id, this.hospitalPayload)
          .then(() => {
            this.active = true
          })
          .catch(({response}) => {
            // TODO: map errors to flat structure for form
            this.errors = response.errors
          })
      }
    }
  }
</script>

<style lang="sass">
  .page-user-form
</style>



// WEBPACK FOOTER //
// src/components/pages/Hospitals/EditHospital.vue